import React from 'react';
import { MarketingArticle } from './marketingArticle.jsx';
import heroImage from '../pictures/Small Trust.it.webp';
import birdImage from '../pictures/Letterbird.avif';
import shopImage from '../pictures/Modern Shop with People.png';

export function TrustIt() {
  return (
    <MarketingArticle
      title="Trust.it"
      kicker="Hosted trust service"
      description="Trust.it lets users and partners experience Back-Step Blockchain through a practical service for permanent records, messages, proofs, and files."
      path="/products"
      heroImage={heroImage}
      heroAlt="Trust.it application"
      primaryAction={{ to: '/contact', label: 'Ask about Trust.it' }}
      secondaryAction={{ to: '/products', label: 'View product options' }}
      sections={[
        {
          tag: 'For users',
          title: 'Store important information without a crypto wallet.',
          image: birdImage,
          imageAlt: 'Letter bird for Trust.it messages',
          paragraphs: [
            'Trust.it is designed for people and organizations that want permanent records without dealing with mining, speculative coins, or blockchain infrastructure.',
            'Users can store public messages, private text, proofs, files, and references depending on the workflow.',
          ],
        },
        {
          tag: 'For partners',
          title: 'A living showcase for customer applications.',
          image: shopImage,
          imageAlt: 'People in a modern shop',
          paragraphs: [
            'Trust.it demonstrates how Back-Step Blockchain can support product verification, customer records, trusted communication, and digital certificates.',
            'Partners can start with the service, then move to dedicated generator hardware or licensing when they need their own deployment.',
          ],
        },
        {
          tag: 'Pricing approach',
          title: 'Pay for records, not subscriptions.',
          paragraphs: [
            'The service is designed around usage-based fees so occasional users are not forced into subscriptions. Reading public records remains simple and accessible.',
            'For commercial deployments, owners of Back-Step Blockchain generators can define pricing that fits their own market.',
          ],
        },
      ]}
    />
  );
}
